export function formatDate(input) {
    let date;
  
    if (typeof input === "number") {
      date = new Date(input * 1000);
    } else {
      date = new Date(input);
    }
  
    return date.toLocaleDateString("en-GB", {
      day: "2-digit",
      month: "long",
      year: "numeric",
    });
  }

 export function reformatToISO(formattedDate) {
    const parts = formattedDate.split(' ');
    const day = parts[0];
    const month = new Date(Date.parse(parts[1] + " 1, 2020")).getMonth() + 1;
    const year = parts[2];
    return `${year}-${String(month).padStart(2, '0')}-${day.padStart(2, '0')}`;
  }